import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import InstagramIcon from '@mui/icons-material/Instagram';
import AlbumIcon from '@mui/icons-material/Album';

export const Footer = () => {
  return (
    <>
      {/* Barra grigia separatrice */}
      <Box
        sx={{
          mt: 4,
          width: '100%',
          height: '1px',
          backgroundColor: '#ccc',
        }}
      />

      <Container
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: { xs: 4, sm: 8 },
          py: { xs: 8, sm: 10 },
          textAlign: 'center',
          backgroundColor: '#000000',
        }}
      >
        {/* Sezione Immagine e Nome */}
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 2,
          }}
        >
          <img
            src="/images/senza-mic-in-nero.ico"
            alt="Foto"
            style={{
              width: '48px',
              height: '48px',
              objectFit: 'contain',
              borderRadius: '50%',
            }}
          />
          <Typography variant="h4"
            sx={{
              fontWeight: 'bold',
              fontSize: '1.2rem',
              userSelect: 'none'
            }}>
            FRANCESCO ALEMANNO
          </Typography>
        </Box>

        {/* Sezione Social Icons */}
        <Stack
          direction="row"
          spacing={2}
          sx={{
            justifyContent: 'center',
          }}
        >
          <IconButton
            color="default"
            size="medium"
            href="https://www.instagram.com/alemannoff/"
            aria-label="Instagram"
            sx={{
              color: 'white',
              transition: 'color 0.3s',
              '&:hover': {
                color: '#3b5998', // Colore di hover di Instagram
              },
            }}
          >
            <InstagramIcon />
          </IconButton>
          <IconButton
            color="default"
            size="medium"
            href="https://www.linkedin.com/in/francesco-alemanno-1a2417261/"
            aria-label="LinkedIn"
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              color: 'white',
              transition: 'color 0.3s',
              '&:hover': {
                color: '#0077b5', // Colore di hover di LinkedIn
              },
            }}
          >
            <LinkedInIcon />
          </IconButton>
          <IconButton
            color="default"
            size="medium"
            href="https://untitled.stream/library/project/dpNJ3R3fAqeEmiy0D6VdQ"
            aria-label="Untitled Stream"
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              color: 'white',
              transition: 'color 0.3s',
              '&:hover': {
                color: '#bbbbbb', // Colore di hover generico
              },
            }}
          >
            <AlbumIcon />
          </IconButton>
        </Stack>
        <Typography variant="h6">
          © {new Date().getFullYear()} Francesco Alemanno. All Rights Reserved.
        </Typography>
      </Container>
    </>
  );
};
